import { ThemeProvider as StyledProvider } from 'styled-components';
import React, { useState } from 'react';

import { ReservationSizes } from '../constants';

import { Theme } from '../components';

export interface ThemePropsTypes {
    theme: Theme;
    children: React.ReactNode;
}

export type Props = { theme: Theme };

export const ThemeProvider = (props: ThemePropsTypes) => {
    const { theme, children } = props;

    const [bottomPaddingReservation, setBottomPaddingReservation] = useState<ReservationSizes | number>(
        ReservationSizes.NONE
    );

    const methods = {
        setBottomPaddingReservation,
    };

    const themeWithMethods = {
        ...theme,
        bottomPaddingReservation,
        methods,
    };

    return <StyledProvider theme={themeWithMethods}>{children}</StyledProvider>;
};
